import { ReactComponent as Spinner } from "../../assets/icons/spinner.svg";
import { useEffect, useState } from "react";

const HubSpotForm = () => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const scriptId = "hubSpot-form-script";
        if (!document.getElementById(scriptId)) {
            const script = document.createElement("script");
            script.id = scriptId;
            script.src = "https://js.hsforms.net/forms/embed/49334692.js";
            script.defer = true;
            script.onload = () => setLoaded(true); // Mark as loaded when script loads
            document.body.appendChild(script);
        } else {
            setLoaded(true); // If script is already there, just mark it as loaded
        }
        return () => {
            setLoaded(false); // Reset when unmounting
        };
    }, []);

    return loaded ?
        <div id="hubSpot-form-script">
            <div
                className="hs-form-frame"
                data-region="na1"
                data-form-id="dde1e0f0-9135-49e3-82ae-de9a39f2f768"
                data-portal-id="49334692"
            />
        </div>
        :
        <div className="flex justify-center items-center">

            <Spinner /> Loading Form
        </div>
};

export default HubSpotForm;


